import { ErrorComponent, type ErrorComponentProps } from '@tanstack/react-router';

import { LoadingPage } from '@nesso/ui/blocks/loading-page';

import { ApiError } from '@/shared/api/http-client';
import { redirectToSignIn } from '@/shared/api/redirect-to-sign-in';

export function ErrorBoundary({ error }: ErrorComponentProps) {
    if (error instanceof ApiError && error.status === 401) {
        redirectToSignIn(true);
        return <LoadingPage />;
    }
    return <ErrorComponent error={error} />;
}
